import { ExternalLink } from "@octopusdeploy/design-system-components";
import { OverviewContainer, OverviewHighlightText } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonViews";
export const ProjectITSMProvidersSettingsHelp = () => (<OverviewContainer>
        <OverviewHighlightText>
            <p>
                ITSM Providers allows users to block the execution of specifically configured deployments unless they have a corresponding approved Change Request. Octopus supports <ExternalLink href="ServiceNowIntegration">Service Now</ExternalLink>{" "}
                and <ExternalLink href="JiraServiceManagementIntegration">Jira Service Management</ExternalLink>.
            </p>
        </OverviewHighlightText>
    </OverviewContainer>);
